<template>
  <c-form>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">Customer Type</label>
      <div class="col-md-9">
        <select-x :size="10" url="/api/v1/customer-type" label="name" placeholder="customer type" @input="changeType"
          v-model="data.type" v-bind:class="{ 'has-error': errors.type_id }" />
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">ID</label>
      <div class="col-md-9">
        <input type="text" class="form-control" v-bind:class="{ 'has-error': errors.customer_id }"
          placeholder="Customer Id" v-model="data.customer_id" v-cloak />
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">Customer Name</label>
      <div class="col-md-9">
        <input type="text" class="form-control" v-bind:class="{ 'has-error': errors.name }" placeholder="Customer Name"
          v-model="data.name" />
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">Perusahaan</label>
      <div class="col-md-9">
        <input type="text" class="form-control" v-bind:class="{ 'has-error': errors.perusahaan }" placeholder="perusahaan"
          v-model="data.perusahaan" />
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">Address</label>
      <div class="col-md-9">
        <input type="text" class="form-control" v-bind:class="{ 'has-error': errors.address }" placeholder="address"
          v-model="data.address" />
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">Phone</label>
      <div class="col-md-9">
        <input type="text" class="form-control" v-bind:class="{ 'has-error': errors.phone }" placeholder="phone"
          v-model="data.phone" />
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">Merek Kendaraan</label>
      <div class="col-md-9">
        <input type="text" class="form-control" v-bind:class="{ 'has-error': errors.phone }" placeholder="merek kendaraan"
          v-model="data.vehicle_brand" />
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">Tipe Kendaraan</label>
      <div class="col-md-9">
        <input type="text" class="form-control" v-bind:class="{ 'has-error': errors.phone }" placeholder="tipe kendaraan"
          v-model="data.vehicle_type" />
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">No. Pol.</label>
      <div class="col-md-9">
        <input type="text" class="form-control" v-bind:class="{ 'has-error': errors.phone }" placeholder="no. pol."
          v-model="data.vehicle_number" />
      </div>
    </div>
    <div class="form-group form-row">
      <label class="col-form-label col-sm-3">Email</label>
      <div class="col-md-9">
        <input type="email" class="form-control" v-bind:class="{ 'has-error': errors.email }" placeholder="email"
          v-model="data.email" />
      </div>
    </div>
  </c-form>
</template>
<script>
import SelectX from "../../../components/SelectX";
import { HTTPAUTH } from '../../../lib/httplib';
export default {
  props: ["data", "errors"],
  name: "CustomerAdd",
  data () {
    return {
    }
  },
  components: {
    SelectX,
  },
  methods: {
    changeType (c) {
      HTTPAUTH.get("/api/v1/customer/generate-id/" + c.id).then(res => {
        this.data.customer_id = res.data.data;
      }).catch(() => {
      })
    }
  }
};
</script>